/**
 * Created by emanuele on 31/01/2017.
 */
/* eslint-disable */
import React from 'react';
import {FormattedNumber} from 'react-intl';
import PropTypes from 'prop-types';
const LocalNumber = ({ value, type }) => {

    if (value === undefined || value === null || value === ''){
        return <span style={{color:'#999999'}}>Non impostato</span>
    }

    if (type === 'currency'){
        return (
            <FormattedNumber
                value={value}
                style="currency"
                currency="EUR"
            />)
    }else if (type === 'percent'){
        return  (
            <FormattedNumber
                value={value}
                style="percent"
                minimumFractionDigits={1}
                maximumFractionDigits={1}
            />)
    }else if (type === 'decimal'){
        return  (
            <FormattedNumber
                value={value}
                style="decimal"
                minimumFractionDigits={2}
                maximumFractionDigits={2}
            />)
    } else {
        return (<FormattedNumber
                value={value}
            />)
    }
}

LocalNumber.PropTypes = {
    value: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
}

LocalNumber.defaultProps = {
    type: 'currency'
};

export default LocalNumber;


/** WEBPACK FOOTER **
 ** ./src/components/LocalNumber.jsx
 **/